import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { HealthPage } from '../../health/health-page.js';

/** `/health` (1.V-2 deliverable 2): guarded like every other authenticated route. */
export const Route = createFileRoute('/health/')({
  staticData: { crumb: 'Health' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: HealthPage,
});
